import React from "react";

const LearningAndDevelopment = () => {
  return <div className="p-8">LearningAndDevelopment</div>;
};

export default LearningAndDevelopment;
